import ProductsAdmin from "./ProductsAdmin";

export default ProductsAdmin;
